export const CALC_LIST_REQUEST = "CALC_LIST_REQUEST";
export const CALC_LIST_SUCCESS = "CALC_LIST_SUCCESS";
export const CALC_LIST_FAIL = "CALC_LIST_FAIL";
